export default {"src":"/_next/static/media/Group-42562.c8c7f149.svg","height":78,"width":83};